import React, { useState, useEffect, useRef } from "react";
import { List, ListItem, ListItemText, Typography, Button, Grid } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import Moment from "moment";
import { useTranslation } from 'react-i18next';

const Comment = ({ WorkOrderCommentsData, readonly }) => {
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedComments, setSortedComments] = useState([]);
  const [maxHeight, setMaxHeight] = useState("400px");
  const { t } = useTranslation('work_order');
  
  const calculateMaxHeight = () => {
    const windowHeight = window.innerHeight;
    const headerHeight = 200;
    const newMaxHeight = windowHeight - headerHeight - 50;
    setMaxHeight(newMaxHeight > 200 ? newMaxHeight : 200);
  };

  useEffect(() => {
    calculateMaxHeight(); 
    window.addEventListener("resize", calculateMaxHeight);

    return () => {
      window.removeEventListener("resize", calculateMaxHeight);
    };
  }, []);

  useEffect(() => {
    setSortedComments([...WorkOrderCommentsData].sort((a, b) => new Date(b.CreateDate) - new Date(a.CreateDate)));
  }, [WorkOrderCommentsData]);

  const sortComments = () => {
    const newOrder = sortOrder === "desc" ? "asc" : "desc";
    const sorted = [...sortedComments].sort((a, b) =>
      newOrder === "desc"
        ? new Date(b.CreateDate) - new Date(a.CreateDate)
        : new Date(a.CreateDate) - new Date(b.CreateDate)
    );
    setSortedComments(sorted);
    setSortOrder(newOrder);
  };

  return (
    <div style={{ padding: "10px" }}>
      <Grid container justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          onClick={sortComments}
          style={{
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            textTransform: "none",
          }}
        >
          {sortOrder === "desc" ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
          <Typography variant="button" style={{ marginLeft: "5px", fontWeight: "bold", color: "white" }}>
            {t('lblDate')}
          </Typography>
        </Button>
      </Grid>

      <div
        style={{
          overflowY: "auto",
          maxHeight: `${maxHeight}px`,
          paddingBottom: "20px",
        }}
      >
        <List>
          {sortedComments.map((comment, index) => (
            <ListItem key={index} divider>
                <ListItemText
                    primary={
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                        {`${comment.Type} - ${comment.Employee}`}
                    </Typography>
                    }
                    secondary={
                    <>
                        <Typography variant="body2" color="textSecondary">
                        {comment.CreateDate ? (
                            <Typography color="textSecondary">
                            {Moment(comment.CreateDate).format("DD/MM/YYYY HH:mm")}
                            </Typography>
                        ) : null}
                        </Typography>
                        <Typography
                        variant="body2"
                        style={{
                            wordBreak: "break-word", 
                            overflowWrap: "break-word", 
                            whiteSpace: "pre-wrap", 
                            width: "100%", 
                        }}
                        >
                        {comment.Dsc}
                        </Typography>
                    </>
                    }
                />
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};

export default Comment;
